import api from "../utils/api";

import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useFlashMessage from "./useFlashMessage";

export default function useAuth() {
    const [authenticated, setAuthenticated] = useState(false);
    const [currentUser, setCurrentUser] = useState({}); // 1. Estado para armazenar os dados do usuário
    const { setFlashMessage } = useFlashMessage();
    const navigate = useNavigate();

    useEffect(() => {
        const token = localStorage.getItem('token');

        if (token) {
            const parsedToken = JSON.parse(token);
            // Corrigido: 'Bearer ' em vez de 'Beare '
            api.defaults.headers.Authorization = `Bearer ${parsedToken}`;
            setAuthenticated(true);

            // 2. Busca os dados do usuário logado (nome, e-mail, foto, etc.)
            api.get('/user/checkuser')
                .then((response) => {
                    setCurrentUser(response.data);
                })
                .catch((error) => {
                    console.error("Erro ao verificar usuário:", error);
                    logout(); // Faz logout se o token for inválido/expirado
                });
        }
    }, []);

    async function register(user) {
        let msgText = 'Cadastro realizado com sucesso!';
        let msgType = 'success';

        try {
            const data = await api.post('/user/register', user).then((response) => response.data);
            await authUser(data);
        } catch (error) {
            msgText = error?.response?.data?.message || 'Erro ao cadastrar';
            msgType = 'error';
        }

        setFlashMessage(msgText, msgType);
    }

    async function login(user) {
        let msgText = 'Login realizado com sucesso!';
        let msgType = 'success';

        try {
            const data = await api.post('/user/login', user).then((response) => response.data);
            await authUser(data);
        } catch (error) {
            msgText = error?.response?.data?.message || 'Erro ao realizar login';
            msgType = 'error';
        }

        setFlashMessage(msgText, msgType);
    }

    async function authUser(data) {
        setAuthenticated(true);
        localStorage.setItem('token', JSON.stringify(data.token));
        api.defaults.headers.Authorization = `Bearer ${data.token}`;
        
        // 3. Atualiza o estado do usuário ao autenticar
        if (data.user) {
            setCurrentUser(data.user);
        } else {
            // Se o login só devolver o token, faz o fetch dos dados
            const userResponse = await api.get('/user/checkuser');
            setCurrentUser(userResponse.data);
        }

        navigate('/loged');
    }

    function logout() {
        const msgText = 'Logout realizado com sucesso!';
        const msgType = 'success';

        setAuthenticated(false);
        setCurrentUser({}); // 4. Limpa os dados do usuário ao sair
        localStorage.removeItem('token');
        api.defaults.headers.Authorization = undefined;
        navigate('/');

        setFlashMessage(msgText, msgType);
    }

    // 5. Retorna currentUser para ser consumido globalmente
    return { authenticated, currentUser, register, logout, login };
}